import { Routes, Route } from "react-router-dom";
import { GlobalContextProvider } from "../context/GlobalContextProvider";
import { Horarios } from "../components/horarios/Horarios";
import { Home } from "../components/home/Home";
import { Detalles } from "../components/detallesView/Detalles";
import { Logout } from "../components/home/Logout";
import { Error401 } from "../components/Errors/Error401";
import { Error400 } from "../components/Errors/Error400";
import { Colaborador } from "../components/Errors/Colaborador";
import '../styles/styles.scss';

export const AppRoutes = () => {
  return (
    <GlobalContextProvider>
        <Routes>
            <Route exact path='/materias' element={<Home />} />
            <Route exact path='/horarios' element={<Horarios />} />
            <Route exact path='/detalles/:materia' element={<Detalles />} />
            <Route exact path='/logout' element={<Logout />} />
            <Route exact path='/401' element={<Error401 />} />
            <Route exact path='/400' element={<Error400 />} />
            <Route exact path='/Colaborador' element={<Colaborador />} />
        </Routes>
    </GlobalContextProvider>
  );
};
